const LEVEL = "preprod";

const commons = {

};

const dev = {
    debug : true,
    logEnabled : true,
    logLevel : 'debug', // debug, info, warning, error
    //googleMapApiKey : 'AIzaSyC8hkqKR6ugzF1yUmy5d7vB49pTRhs9UTg',
    server : 'http://localhost:8000',
};
const preprod = {
    debug : true,
    logEnabled : true,
    logLevel : 'warning', // debug, info, warning, error
    //googleMapApiKey : 'AIzaSyC8hkqKR6ugzF1yUmy5d7vB49pTRhs9UTg',
    server : 'https://api.brera.artcentrica.com',
};

const prod = {
    debug : false,
    logEnabled : true,
    logLevel : 'warning', // debug, info, warning, error
    //googleMapApiKey : 'AIzaSyC8hkqKR6ugzF1yUmy5d7vB49pTRhs9UTg',
    server : 'https://api.brera.artcentrica.com',
};

let config;

switch (LEVEL) {
    case "prod":
        config = Object.assign(commons, prod);
        break;
    case "preprod":
        config = Object.assign(commons, preprod);
        break;
    case "dev":
    default:
        config = Object.assign(commons, dev);
        break;
}

export default config;